export enum TwilioPhoneNumberOrigin {
  Twilio = 'twilio',
  Hosted = 'hosted',
}
